import { Card, Group, Image, MantineTheme, Tooltip } from "@mantine/core";
import { API_URL, APP_ID } from "../../../config";

interface VisitasData {
    tipo: string,
    datos: string[]
}

function htmlUnescape(html: string) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
}

export function AutorizacionGeneralViewColumnsOverrides(theme: MantineTheme) {
    return {
        3: {
            render: (value: unknown) => {
                const data = htmlUnescape(value as string);
                const rec: VisitasData = JSON.parse(data as string);

                if (rec.tipo === 'IMAGEN' || rec.tipo === 'IMAGEN_MULTIPLE') {

                    return (
                        <Group align="flex-start" spacing="xs">
                            {rec.datos.map((img, index) => (
                                <Tooltip label=
                                    {
                                        <Card>
                                            <Image
                                                key={index}
                                                src={`${API_URL}/${APP_ID}/serve/${img}`}
                                                alt={`Imagen ${index + 1}`}
                                                maw="600px"
                                                mt="auto"
                                            />
                                        </Card>
                                    }>
                                    <Image
                                        key={index}
                                        src={`${API_URL}/${APP_ID}/serve/${img}`}
                                        alt={`Imagen ${index + 1}`}
                                        maw="30px"
                                        mt="auto"
                                    />
                                </Tooltip>
                            ))}
                        </Group>
                    );
                }
                return rec.datos.length > 0 ? rec.datos[0] : '';
            }
        }
    }
}